import { render, staticRenderFns } from "./CandidateState.vue?vue&type=template&id=645f5cb8&"
import script from "./CandidateState.vue?vue&type=script&lang=js&"
export * from "./CandidateState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports